// Filename: ClientList.js
// Description: This component renders a list of users returned after searching.

import React from "react";
import { PeopleFill } from 'react-bootstrap-icons';

function ClientList({ clients, onSelect }) {
  return (
    <React.Fragment>
      <div className="card border border-light m-0 h-100">
        <div className="card-header">
          <h3 className="text-center">
            <PeopleFill className="me-2 text-primary" />
            Clients
          </h3>
        </div>
        <div className="card-body">
          {/* List container with fixed height and scrolling */}
          <div className="overflow-auto" style={{ maxHeight: "300px" }}> 
            <ul className="list-group border border-light">
              {clients.map((client) => (
                <li className="list-group-item list-group-item-action" key={client.clientID}>
                  <div className="row">
                    <div 
                      onClick={() => onSelect(client)} 
                      role="button" 
                      tabIndex="0" 
                      onKeyDown={(e) => { 
                        if (e.key === 'Enter') { 
                          onSelect(client);
                        }
                      }}
                      className="col-12"
                    >
                      <div className="row">
                        <div className="col-2 d-flex justify-content-center align-items-center">
                          <img
                            src={client.photo}
                            alt="profile picture"
                            className="rounded-circle"
                            style={{
                              width: "64px",
                              height: "64px",
                              objectFit: "cover" 
                            }} 
                          />
                        </div>
                        <div className="col-10 row">
                          <p className="col-10 mb-0 text-nowrap mb-0">
                            <b>Name: </b>
                            {client.firstName + " " + client.lastName}
                          </p>
                          <p className="col-10 mb-0 text-nowrap mb-0">
                            <b>Email: </b>
                            {client.email}
                          </p>
                          <p className="col-10 mb-0">
                            <b>Phone Number: </b>
                            {client.areaCode +
                              "-" +
                              client.telPrefix +
                              "-" +
                              client.lineNum}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default ClientList;